module.exports = __webpack_public_path__ + "img/Pfade_Fynn_13.835b2bed.png";